import { render, staticRenderFns } from "./patient-profile-basic.html?vue&type=template&id=d3a941ea&scoped=true&external"
import script from "./patient-profile-basic.js?vue&type=script&lang=js&external"
export * from "./patient-profile-basic.js?vue&type=script&lang=js&external"
import style0 from "./patient-profile-basic.scss?vue&type=style&index=0&id=d3a941ea&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3a941ea",
  null
  
)

export default component.exports